import { Injectable } from '@angular/core';
import { globals } from '../utils/globals';
import { ImaginaeToken } from '../app/models/imaginae-token.model';
import { TransferStateService } from './transfer-state.service';
import { InfoService } from './info.service';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class TokenStorageService {
  constructor(
    private _globals: globals,
    private _localStorageService: LocalStorageService,
    private _transferStateService: TransferStateService,
    private _infoService: InfoService
  ) {}

  signOut(): void {
    this._transferStateService.setToken(null);
    this._localStorageService.removeItem(
      this._globals.constants.STORAGE_TOKEN_INFO
    );
    this._localStorageService.removeItem(
      this._globals.constants.STORAGE_USER_INFO
    );
  }

  public getToken(): ImaginaeToken | null {
    let tokenData: ImaginaeToken | null = this._transferStateService.getToken();

    //console.log('getToken=' + tokenData);

    return tokenData;
  }

  public saveToken(token: ImaginaeToken): void {
    this._transferStateService.setToken(token);
    this._localStorageService.setObject(
      this._globals.constants.STORAGE_TOKEN_INFO,
      token
    );
  }

  public getRefreshToken(): string | null {
    let tokenData: ImaginaeToken = this.getToken()!;
    return tokenData.getRefreshToken();
  }

}
